
import React, { createContext, useState } from 'react';

const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [SharedActiveMenu, setSharedActiveMenu] = useState(null);
  const [SharedAuthUser, setSharedAuthUser] = useState({});
  const [isSidebarHidden, setSidebarHidden] = useState(false);
  const [isToggleActive, setToggleActive] = useState(false);

  return (
    <AppContext.Provider value={{
    	SharedAuthUser, setSharedAuthUser,
    	SharedActiveMenu, setSharedActiveMenu,
    	isSidebarHidden, setSidebarHidden,
    	isToggleActive, setToggleActive
    }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };